import { Injectable } from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {

  constructor(
    private updates: SwUpdate,
    private snackbar: MatSnackBar
  ) { }

  inicializar(): void {
    // Angular 17+: propriedades 'available' e 'activated' removidas
    // TODO: Adaptar para nova API de atualização do Service Worker
    // this.updates.available.subscribe(() => this.abrirSnackAtualizar());
    // this.updates.activated.subscribe(() => this.abrirSnackAtualizar());
  }

  private abrirSnackAtualizar(): void {
    this.snackbar.open('Nova versão disponivel', 'Atualizar', {horizontalPosition: 'end'})
      .onAction().subscribe(() => document.location.reload());
  }
}
